module.exports = __webpack_public_path__ + "static/media/03.77a6e5d3.jpg";